import { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { when } from "util/support";
import When from "ui/support/When";
import { Collection } from "ui/support/Resource";
import {
    Column,
    useColumns,
    useTransaction,
    useStyles
} from "./support";

const GeneralInfo = () => {
    const { root, item } = useStyles();

    const { getColumn } = useTransaction();

    const { withColumns } = useColumns();

    return (
        <Collection
            sx={root}
            collection={withColumns([
                getColumn(Column.CreatedAt),
                getColumn(Column.Status),
                getColumn(Column.FundStatus),
                getColumn(Column.UpdatedAt),
                getColumn(Column.SettlementStatus),
                getColumn(Column.SettlementStatusDateTime),
                getColumn(Column.IsSettled),
                getColumn(Column.RefId),
                getColumn(Column.SettledDate),
                getColumn(Column.LocalTime)
            ])}
            renderResource={({
                field,
                headerName,
                value,
                component: Component
            }) => (
                <Box
                    key={field}
                    sx={item}
                >
                    <Typography variant='caption'>{headerName}:</Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'flex-end'
                        }}
                    >
                        <When
                            if={[undefined, null, ''].includes(value)}
                            then='-'
                            else={() => (
                                when(
                                    Boolean(Component),
                                    () => (
                                        <Component
                                            label={value}
                                        />
                                    ),
                                    value
                                )
                            )}
                        />
                    </Box>
                </Box>
            )}
        />
    );
};

export default memo(GeneralInfo);
